import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Box, Container, Typography, Divider } from "@mui/material";

class Privacy extends Component {
  render() {
    return (
      <Box sx={{ py: 13 }}>
        <Helmet>
          <title>Privacy Policy | F9 Info Technologies</title>
          <meta name="description" content="Learn how F9 Info Technologies collects, uses, and protects your personal information." />
        </Helmet>
        <Container maxWidth="lg" className="container">
          <Typography variant="h1" component="h1" className="page-title" align="center" sx={{ mb: 2 }}>
            Privacy Policy
          </Typography>
          <Typography align="center" sx={{ mb: 6, color: "text.secondary" }}>
            Effective Date: January 1, 2024
          </Typography>

          <Section title="1. Introduction">
            F9 Info Technologies Private Limited ("F9 Tech", "we", "our", or "us") is committed to protecting
            your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your
            information when you visit our website or engage our services.
          </Section>

          <Section title="2. Information We Collect">
            We may collect the following types of information:
            <br /><br />
            <strong>Personal Information:</strong> Name, email address, phone number, and company details
            provided when you contact us or request a quote.
            <br /><br />
            <strong>Usage Data:</strong> IP address, browser type, pages visited, time spent on pages, and
            other diagnostic data collected automatically when you use our website.
            <br /><br />
            <strong>Project Information:</strong> Documents, requirements, and files shared with us during
            the course of a service engagement.
          </Section>

          <Section title="3. How We Use Your Information">
            We use the information we collect to:
            <br /><br />
            • Respond to your enquiries and deliver our services<br />
            • Send project updates, invoices, and service communications<br />
            • Improve our website, products, and services<br />
            • Comply with legal obligations<br />
            • Send promotional content with your consent (you may opt out at any time)
          </Section>

          <Section title="4. Sharing of Information">
            We do not sell, trade, or rent your personal information to third parties. We may share
            information with trusted service providers who assist us in operating our website and delivering
            services, provided they agree to keep your information confidential.
            <br /><br />
            We may disclose information if required by law or to protect the rights, property, or safety of
            F9 Info Technologies, our clients, or others.
          </Section>

          <Section title="5. Cookies">
            Our website uses cookies to enhance your browsing experience. Cookies are small data files placed
            on your device. You may disable cookies through your browser settings; however, some features of
            our website may not function correctly without them.
          </Section>

          <Section title="6. Data Security">
            We implement industry-standard security measures to protect your personal information from
            unauthorized access, alteration, disclosure, or destruction. However, no method of transmission
            over the Internet is 100% secure, and we cannot guarantee absolute security.
          </Section>

          <Section title="7. Data Retention">
            We retain your personal information only for as long as necessary to fulfil the purposes outlined
            in this policy, comply with legal obligations, or resolve disputes. Project-related data is
            typically retained for five (5) years after project completion.
          </Section>

          <Section title="8. Your Rights">
            You have the right to:
            <br /><br />
            • Access the personal information we hold about you<br />
            • Request correction of inaccurate data<br />
            • Request deletion of your data (subject to legal obligations)<br />
            • Withdraw consent for marketing communications at any time
            <br /><br />
            To exercise these rights, contact us at <a href="mailto:projects@f9tech.com">projects@f9tech.com</a>.
          </Section>

          <Section title="9. Third-Party Links">
            Our website may contain links to third-party websites. We are not responsible for the privacy
            practices or content of those sites. We encourage you to review the privacy policies of any
            third-party sites you visit.
          </Section>

          <Section title="10. Changes to This Policy">
            We may update this Privacy Policy from time to time. Changes will be posted on this page with
            an updated effective date. We encourage you to review this policy periodically.
          </Section>

          <Section title="11. Contact Us" last>
            If you have any questions or concerns about this Privacy Policy, please contact:
            <br /><br />
            <strong>F9 Info Technologies Private Limited</strong><br />
            Vinayagar Heights, Sampath Vinayaka Temple Road,<br />
            Waltair Uplands, Opp. Kalyan Jewellers,<br />
            Visakhapatnam – 530003, Andhra Pradesh, India<br />
            Email: <a href="mailto:projects@f9tech.com">projects@f9tech.com</a><br />
            Phone: <a href="tel:+918919693567">+91 891 969 3567</a>
          </Section>
        </Container>
      </Box>
    );
  }
}

function Section({ title, children, last }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" component="h2" sx={{ mb: 1.5, fontWeight: 600, color: "#002E69" }}>
        {title}
      </Typography>
      <Typography variant="body1" component="div" sx={{ lineHeight: 1.8, color: "#444" }}>
        {children}
      </Typography>
      {!last && <Divider sx={{ mt: 4 }} />}
    </Box>
  );
}

export default Privacy;
